import React, { useEffect, useContext } from 'react';
import styled from 'styled-components';
import { Nav, Navbar, NavItem } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import MenuIcon from '@material-ui/icons/Menu';

import AccountAvatarMenu from '../Login/AccountAvatarMenu';
import { fetchWorkspaces } from '../../actions/workspaces';
import { LayoutUIContex } from '../Layout/LayoutUIContext';

const TOPBAR_HEIGHT = 56;

const StyledNavbar = styled(Navbar)`
    background: #fff !important;
    height: ${TOPBAR_HEIGHT}px;
    padding: 0 clamp(20px, 4vw, 28px);
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
`;

const BurgerBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: 0;
    background: transparent;
    border-radius: 10px;
    margin-right: 12px;
    color: #111827;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    &:hover {
        background: rgba(17, 24, 39, 0.06);
    }
    &:focus {
        outline: none;
    }
    &:focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.28);
        background: rgba(17, 24, 39, 0.06);
    }
`;

const Actions = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
`;

const NavBar = () => {
    const dispatch = useDispatch();
    const login = useSelector((s) => s.login);
    const workspaces = useSelector((s) => s.workspaces);
    const { setOpen, isDesktop } = useContext(LayoutUIContex);

    useEffect(() => {
        if (login?.userDetails?.isLoggedIn === true && !workspaces.fetched) {
            dispatch(fetchWorkspaces());
        }
    }, [login?.userDetails?.isLoggedIn, workspaces.fetched, dispatch]);

    return (
        <StyledNavbar color="white" light expand="md" className="app-navbar">
            {!isDesktop && (
                <BurgerBtn
                    type="button"
                    aria-label="Open menu"
                    onClick={() => setOpen(true)}
                >
                    <MenuIcon />
                </BurgerBtn>
            )}

            <Actions>
                <Nav navbar className="align-items-center">
                    <NavItem>
                        <AccountAvatarMenu />
                    </NavItem>
                </Nav>
            </Actions>
        </StyledNavbar>
    );
};

export default NavBar;
